var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('node-view-wrapper',{staticClass:"wrapper"},[_c('button',{class:_vm.node.attrs.class,on:{"click":_vm.handleClick}},[_vm._v(" "+_vm._s(_vm.node.attrs.label)+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }